import React, { useState, useRef} from 'react';
import './home/home.css';
import '../App.css'
import './rightbtn.css'
import { connect } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { useLang } from '../hook/UseLang';
import CONTENT from '../contents/nav.js';
import FACI from '../contents/facilities.js'
const RightSizePops = ({control}) => {
    const navigate = useNavigate()
    const [lang, setLang] = useLang()
    const [activeTab, setActiveTab] = useState(null);
    const [bookingInfo, setBookingInfo] = useState({
        startDate: new Date().toLocaleDateString(),
        people:1,
        roomCount:1,
        stay:1
    })
    const mainRef = useRef()
    const btnRef = useRef()

    const handleTabClick = (tab) => {
        setActiveTab(activeTab === tab ? null : tab);
    };
    const handleClick = () =>{
        if(mainRef.current.classList.contains('is-book-opened')){
            //opened
            mainRef.current.classList.remove('is-book-opened');
            btnRef.current.classList.remove('book-btn-open-bg');
        } else {
            //closed
            mainRef.current.classList.add('is-book-opened');
            btnRef.current.classList.add('book-btn-open-bg');

        }
    }
    const handleGoBook = () => {
        const copy = {...bookingInfo}
        const newDate = copy.startDate
        if(newDate.includes('-')){
            const [year, month, date] = newDate.split('-')
            copy.startDate = `${date}/${month}/${year}`
        }
        const link = document.createElement('a');
        const {startDate, roomCount, people, stay} = copy
        link.href = `/reservation?lang=${lang}&startDate=${startDate}&roomCount=${roomCount}&occupancy=${people}&stay=${stay}`;
        link.setAttribute('startDate', newDate);
        link.setAttribute('roomCount', copy.roomCount);
        link.setAttribute('people', copy.people);
        link.setAttribute('stay', copy.stay);
        link.target = '_blank';
        document.body.appendChild(link);
        link.click();
    }
    return (
        <div ref={mainRef} className="is-book-closed overflow-hidden flex flex-row items-start justify-start book-top playfair-display d-show-m-hidden absolute" style={{opacity:control?.hideMenu?0:1, transition:'all .5s ease', zIndex:9999999}}>
            <div className='relative w-full h-[144px] book-height flex flex-row items-center'>
                <div ref={btnRef} onClick={() => handleClick()} className='text-white text-[16px] vert-text open_btn h-full flex flex-row items-center justify-center cursor-pointer select-none book-btn-close-bg text-d-16'>{CONTENT.reservation[lang]}</div>
                <div className='flex flex-row items-center justify-center text-d-12 font-[500] text-white border-l border-l-[#989188] h-full bg-[#DDD7CF] px-[14px]' style={{flex:1, gap:12}}>
                    <div className='flex flex-col items-start text-d-14' style={{flex:3}}>
                        <div className='mb-[12px] text-[#3D1B00] text-d-12 playfair-display'>{FACI.checkIn[lang]}</div>
                        <div className='w-full h-[58px] bg-[#C3BDB3] relative'>
                            <input onChange={(e) => setBookingInfo(prev => {return {...prev, startDate:e.target.value}})} type='date' className='w-full h-full bg-transparent text-[#3D1B00] text-d-12 playfair-display px-[12px] outline-none' />
                        </div>
                    </div>
                    <div className='flex flex-col items-start text-d-14' style={{flex:1}}>
                        <div className='mb-[12px] text-[#3D1B00] text-d-12 playfair-display'>Stay</div>
                        <div className='w-full h-[58px] bg-[#C3BDB3] relative'>
                            <select onChange={(e) => setBookingInfo(prev => {return {...prev, stay:e.target.value}})} className='w-full h-full bg-transparent text-[#3D1B00] text-center'>
                                <option value="1">1</option>
                                <option value="2">2</option>
                                <option value="3">3</option>
                                <option value="4">4</option>
                                <option value="5">5</option>
                            </select>
                        </div>
                    </div>
                    <div className='flex flex-col items-start text-d-14' style={{flex:2}}>
                        <div className='mb-[12px] text-[#3D1B00] text-d-12 playfair-display'>{CONTENT.numOfRooms[lang]}</div>
                        <div className='w-full h-[58px] bg-[#C3BDB3] relative'>
                            <select onChange={(e) => setBookingInfo(prev => {return {...prev, roomCount:e.target.value}})} className='w-full h-full bg-transparent text-[#3D1B00] text-center'>
                                <option value="1">1 {CONTENT.roomText[lang]}</option>
                                <option value="2">2 {CONTENT.roomsText[lang]}</option>
                                <option value="3">3 {CONTENT.roomsText[lang]}</option>
                                <option value="4">4 {CONTENT.roomsText[lang]}</option>
                                <option value="5">5 {CONTENT.roomsText[lang]}</option>
                            </select>
                        </div>
                    </div>
                    <div className='flex flex-col items-start text-d-14' style={{flex:1}}>
                        <div className='mb-[12px] text-[#3D1B00] text-d-12 playfair-display'>People</div>
                        <div className='w-full h-[58px] bg-[#C3BDB3] relative'>
                            <select onChange={(e) => setBookingInfo(prev => {return {...prev, people:e.target.value}})} className='w-full h-full bg-transparent text-[#3D1B00] text-center '>
                                <option value="1">1 {CONTENT.personText[lang]}</option>
                                <option value="2">2 {CONTENT.personText[lang]}</option>
                                <option value="3">3 {CONTENT.personText[lang]}</option>
                                <option value="4">4 {CONTENT.personText[lang]}</option>
                                <option value="5">5 {CONTENT.personText[lang]}</option>
                                <option value="5">6 {CONTENT.personText[lang]}</option>
                            </select>
                        </div>
                    </div>
                </div>
                <a target='_blank' href='https://book-directonline.com/properties/twentyonewhitfield' className='w-[147px] h-full bg-[#96805D] flex flex-row items-center justify-center text-white playfair-display cursor-pointer select-none'>{CONTENT.searchText[lang]}</a>
            </div>
        </div>
    );
};

export default connect((store)=>{
    return{
      control:store.controlReducer,
    }
  })(RightSizePops)